import { Helmet } from 'react-helmet-async';
import ReactMarkdown from 'react-markdown';
import { useEffect } from 'react';
import { Box, Button, Container, Paper, Typography } from '@mui/material';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { useNavigate } from 'react-router-dom';
import { PRIVACY_POLICY } from '../constants/legal.js';

export default function PrivacyPolicyPage() {
  const navigate = useNavigate();
  const handleBack = () => {
    if (window.history.length > 1) {
      navigate(-1);
    } else {
      navigate('/');
    }
  };

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }, []);

  return (
    <Container maxWidth="md" sx={{ py: { xs: 6, md: 8 } }}>
      <Helmet>
        <title>Privacy Policy - BrainLoop</title>
        <meta name="description" content="Read BrainLoop's privacy policy to understand how we collect, use, and protect your personal data." />
        <link rel="canonical" href="https://brainloop.app/privacy" />
        <meta name="robots" content="noindex" />
      </Helmet>
      <Paper
        elevation={1}
        sx={{
          p: { xs: 3, md: 4 },
          borderRadius: 3,
          border: (theme) => `1px solid ${theme.palette.divider}`,
        }}
      >
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 2 }}>
          <Button
            onClick={handleBack}
            startIcon={<ArrowBackIcon />}
            color="inherit"
            sx={{ textTransform: 'none' }}
          >
            Back
          </Button>
          <Typography variant="h3" component="h1">
            Privacy Policy
          </Typography>
        </Box>
        <Typography variant="body1" color="text.secondary" sx={{ mb: 3 }}>
          Learn how BrainLoop.io collects, uses, and protects your information.
        </Typography>
        <Box
          sx={(theme) => ({
            '& .legal-markdown h1': { ...theme.typography.h4, marginBottom: 2 },
            '& .legal-markdown h2': { ...theme.typography.h5, marginTop: 2.5, marginBottom: 1.5 },
            '& .legal-markdown h3': { ...theme.typography.h6, marginTop: 2, marginBottom: 1 },
            '& .legal-markdown p': { ...theme.typography.body1, marginBottom: 1.5 },
            '& .legal-markdown ul': { paddingLeft: 3, marginBottom: 1.5 },
            '& .legal-markdown li': { marginBottom: 0.75 },
            '& .legal-markdown strong': { fontWeight: 700 },
          })}
        >
          <ReactMarkdown className="legal-markdown">
            {PRIVACY_POLICY}
          </ReactMarkdown>
        </Box>
      </Paper>
    </Container>
  );
}

